import { useSyncExternalStore } from 'react';

/*
 * The width at which a right-docked panel stops being a panel beside the page
 * and starts being the page. Read from the token the styling uses rather than
 * written out again here: a second copy of 680 is free to drift from
 * `max-mobile:`.
 */
function coveringQuery(): MediaQueryList {
  const breakpoint = getComputedStyle(document.documentElement).getPropertyValue(
    '--breakpoint-mobile',
  );

  return window.matchMedia(`(width < ${breakpoint})`);
}

/**
 * The same answer, asked once rather than watched.
 *
 * For the moments that are not a render: what the chat drawer should start as
 * is decided before anything is drawn, and a hook cannot be asked there.
 */
export function isBelowMobile(): boolean {
  return coveringQuery().matches;
}

function subscribeToWidth(onChange: () => void): () => void {
  const query = coveringQuery();
  query.addEventListener('change', onChange);

  return () => query.removeEventListener('change', onChange);
}

/**
 * Whether the window is narrow enough that a docked panel covers the page.
 *
 * Both panels on the right edge need this: covering changes what they are, not
 * just how wide they are — a covering panel is a modal, and a covering panel
 * has no width worth remembering.
 */
export function useBelowMobile(): boolean {
  return useSyncExternalStore(
    subscribeToWidth,
    () => coveringQuery().matches,
    /* Rendered without a window, nothing covers anything. */
    () => false,
  );
}
